// test2295
(2295 && 0);
